


import React, { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import ChatWindow from "../components/ChatWindow";

const MayiiqX = () => {
    const [selectedSession, setSelectedSession] = useState(null);
    const [sessions, setSessions] = useState([]);

    return (
        <>
            <CssBaseline />
            <Box
                sx={{
                    display: "flex",
                    height: "100vh",
                    backgroundColor: "#282c34",
                    color: "white",
                }}
            >
                {/* Sidebar fixed width */}
                <Box sx={{ flexShrink: 0 }}>
                <Sidebar
                    setSelectedSession={setSelectedSession}
                    sessions={sessions}
                />
                </Box>

                {/* Main Content */}
                <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    {/* Header stays on top */}
                    <Box sx={{ flexShrink: 0 }}>
                        <Header />
                    </Box>

                    {/* Chat window fills the remaining space and scrolls if needed */}
                    <Box
                        sx={{
                            flex: 1,
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <ChatWindow
                            sessionId={selectedSession}
                            setSessions={setSessions}
                        />
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default MayiiqX;

